<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Delivery Order Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="add" @click="cusAdd"
        >Add</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis"
        >Delete</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="#5b3cc4"
        type="filled"
        icon="list"
        @click="goPrint"
        v-if="btndis"
        >Print</vs-button
      >
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <putadd
        v-if="addshow"
        key="addshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></putadd>
      <aggrid
        v-if="gridshow"
        key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></aggrid>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import putadd from "./putadd";

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
import JsBarcode from "jsbarcode/bin/JsBarcode";

export default {
  data() {
    return {
      totalGw: 0,
      totalPck: 0,
      totalWithVat: 0,
      amountTotal: 0,
      vatTotal: 0,
      whtTotal: 0,
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      addshow: false,
      gridshow: false,
      btndis: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goPrint", label: "PrintQR" },
        { act: "goDetail", label: "Inbdetails" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    textToBase64Barcode(text) {
      var canvas = document.createElement("canvas");
      JsBarcode(canvas, text, { format: "CODE39" });
      return canvas.toDataURL("image/png");
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    cvDate2(date) {
      let d = new Date(date);
      let dformat = [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/");
      return dformat;
    },
    ThaiNumberToText(Number) {
      Number = Number.replace(/๐/gi, "0");
      Number = Number.replace(/๑/gi, "1");
      Number = Number.replace(/๒/gi, "2");
      Number = Number.replace(/๓/gi, "3");
      Number = Number.replace(/๔/gi, "4");
      Number = Number.replace(/๕/gi, "5");
      Number = Number.replace(/๖/gi, "6");
      Number = Number.replace(/๗/gi, "7");
      Number = Number.replace(/๘/gi, "8");
      Number = Number.replace(/๙/gi, "9");
      return this.ArabicNumberToText(Number);
    },
    ArabicNumberToText(inNumber) {
      let Number = this.CheckNumber(inNumber);
      let NumberArray = new Array(
        "ศูนย์",
        "หนึ่ง",
        "สอง",
        "สาม",
        "สี่",
        "ห้า",
        "หก",
        "เจ็ด",
        "แปด",
        "เก้า",
        "สิบ"
      );
      let DigitArray = new Array(
        "",
        "สิบ",
        "ร้อย",
        "พัน",
        "หมื่น",
        "แสน",
        "ล้าน"
      );
      let BahtText = "";
      if (isNaN(Number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
      } else {
        if (Number - 0 > 9999999.9999) {
          return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
          Number = Number.split(".");
          if (Number[1].length > 0) {
            Number[1] = Number[1].substring(0, 2);
          }
          let NumberLen = Number[0].length - 0;
          for (let i = 0; i < NumberLen; i++) {
            let tmp = Number[0].substring(i, i + 1) - 0;
            if (tmp != 0) {
              if (i == NumberLen - 1 && tmp == 1) {
                BahtText += "เอ็ด";
              } else if (i == NumberLen - 2 && tmp == 2) {
                BahtText += "ยี่";
              } else if (i == NumberLen - 2 && tmp == 1) {
                BahtText += "";
              } else {
                BahtText += NumberArray[tmp];
              }
              BahtText += DigitArray[NumberLen - i - 1];
            }
          }
          BahtText += "บาท";
          if (Number[1] == "0" || Number[1] == "00") {
            BahtText += "ถ้วน";
          } else {
            let DecimalLen = Number[1].length - 0;
            for (let i = 0; i < DecimalLen; i++) {
              let tmp = Number[1].substring(i, i + 1) - 0;
              if (tmp != 0) {
                if (i == DecimalLen - 1 && tmp == 1) {
                  BahtText += "เอ็ด";
                } else if (i == DecimalLen - 2 && tmp == 2) {
                  BahtText += "ยี่";
                } else if (i == DecimalLen - 2 && tmp == 1) {
                  BahtText += "";
                } else {
                  BahtText += NumberArray[tmp];
                }
                BahtText += DigitArray[DecimalLen - i - 1];
              }
            }
            BahtText += "สตางค์";
          }
          return BahtText;
        }
      }
    },
    CheckNumber(Number) {
      var decimal = false;
      Number = Number.toString();
      Number = Number.replace(/ |,|บาท|฿/gi, "");
      for (var i = 0; i < Number.length; i++) {
        if (Number[i] == ".") {
          decimal = true;
        }
      }
      if (decimal == false) {
        Number = Number + ".00";
      }
      return Number;
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
    },
    grid() {
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.$store.dispatch("setReportGrid", 0);
      setTimeout(() => {
        if (this.gridshow == false) {
          this.gridshow = true;
        } else {
          this.gridshow = false;
        }
      }, 300);
    },
    goDetail() {
      this.btndis = true;
      this.$router.replace("/receiptsdetails/" + this.recid);
    },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      this.daday = dd;
      this.damonth = mm;
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + yyyy;
    },
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    getArrayData(data) {
      // console.log(data);
      this.arData = [];

      this.totalGw = 0;
      this.totalPck = 0;
      this.amountTotal = 0;
      this.vatTotal = 0;
      this.whtTotal = 0;
      this.totalWithVat = 0;

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          {
            text: item.description + " " + item.remarkDetail,
            fontSize: 8,
            bold: true,
            alignment: "left",
          },
          {
            text: this.formatnumber(item.qtyAmount),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: item.qtyUnit,
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          {
            text: this.formatnumber(item.unitPrice),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.formatnumber(item.totalAmount),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
        ]);

        i++;

        this.totalGw = this.totalGw + item.itemgw;
        this.totalPck = this.totalPck + item.itempck;
        this.amountTotal = this.amountTotal + item.totalAmount;
        this.vatTotal = this.vatTotal + item.amountVat;
        this.whtTotal = this.whtTotal + item.amountWht;
        this.totalWithVat = this.amountTotal + this.vatTotal - this.whtTotal;
        // console.log(item.totalgw);
      });
    },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          // var dataURL = canvas.toDataURL("image/png");
          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = (error) => {
          reject(error);
        };

        img.src = url;
      });
    },
    async goPrint() {
      // const moment = require("moment");

      this.contents = [];

      this.goDate();

      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.recid,
            // from: '2022-01-11'
          };

          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/dlvorders/printDo`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data)
            // this.getArrayData(response.data.receipts);
            let ptype = "";

            if (response.data.dlvOrders[0].status == "PRINTED") {
              ptype = "COPY";
            } else {
              ptype = "ORIGINAL";
            }

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              images: {
                // logo :'https://codingthailand.com/site/img/garuda_logo.png',
                logo: require("./login.png"),
              },
              content: [
                {
                  text: ptype,
                  fontSize: 30,
                  // style: "title",

                  alignment: "right",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "DELIVERY ORDER",
                  fontSize: 30,
                  // style: "title",

                  alignment: "right",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 10],
                },
                {
                  // image: await this.getBase64ImageFromURL(
                  //   require('./login.png')
                  // )
                },
                {
                  margin: [0, -60, 0, 20],

                  image: "logo",
                  width: 180,
                },
                {
                  text:
                    "AOTGA CUSTOMER CODE : " +
                    response.data.dlvOrders[0].businessPartnersCode,
                  fontSize: 16,
                  // style: "title",

                  alignment: "right",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "D/O NUMBER : " + response.data.dlvOrders[0].number,
                  fontSize: 16,
                  // style: "title",

                  alignment: "right",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 10],
                },
                {
                  text: "D/O NUMBER : " + response.data.dlvOrders[0].taxid,
                  fontSize: 16,
                  // style: "title",

                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "CONSIGNEE : " + response.data.dlvOrders[0].ename,
                  fontSize: 16,
                  // style: "title",

                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text:
                    "ADDRESS : " +
                    response.data.dlvOrders[0].ename +
                    " " +
                    response.data.dlvOrders[0].eadd1 +
                    " " +
                    response.data.dlvOrders[0].eamoo +
                    " " +
                    response.data.dlvOrders[0].eabuild +
                    " " +
                    response.data.dlvOrders[0].eafloor +
                    " " +
                    response.data.dlvOrders[0].easoi +
                    " " +
                    response.data.dlvOrders[0].earoad +
                    " " +
                    response.data.dlvOrders[0].eadd2 +
                    " " +
                    response.data.dlvOrders[0].eadd3 +
                    " " +
                    response.data.dlvOrders[0].eadd4 +
                    " " +
                    response.data.dlvOrders[0].zcode,
                  fontSize: 16,
                  // style: "title",

                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 10],
                },
                {
                  text: "AIRWAY BILL NO",
                  fontSize: 16,
                  // style: "title",

                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [80, 0, 0, -20],
                },
                {
                  text: "ARRIVAL FLIGHT",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [200, 0, 0, -20],
                },
                {
                  text: "ARRIVAL DATE",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [320, 0, 0, 0],
                },
                {
                  text: "MAWB",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text: response.data.dlvOrders[0].mawb,
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [80, 0, 0, -20],
                },
                {
                  text: response.data.dlvOrders[0].vesselname,
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [200, 0, 0, -20],
                },
                {
                  text: this.cvDate2(response.data.dlvOrders[0].dcldate),
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [320, 0, 0, 0],
                },
                {
                  text: "HAWB",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text: response.data.dlvOrders[0].hawb,
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [80, 0, 0, 10],
                },
                // {
                //   text: response.data.dlvOrders[0].edescription,
                //   fontSize: 12,
                //   // style: "title",

                //   // alignment: "left",
                //   // [left, top, right, bottom]
                //   // margin: [100, -20, 0, 0],
                //   margin: [420, 0, 0, 40],
                // },
                                {
                  text:
                    "CONTENTS : " + response.data.dlvOrders[0].edescription,
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text:
                    "PIECES : " +
                    response.data.dlvOrders[0].itempck +
                    " " +
                    response.data.dlvOrders[0].packagesCode,
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text:
                    "WEIGHT : " +
                    response.data.dlvOrders[0].itemgw +
                    " " +
                    response.data.dlvOrders[0].gwunit,
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [80, 0, 0, 30],
                },
                {
                  text: "____________________________________________________________________________________",
                  fontSize: 16,
                  // style: "title",
                  bold: true,

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 20],
                },
                {
                  text: "ขื่อ / Name",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text: "____________________________________________________________",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [170, 0, 0, 20],
                },
                {
                  text: "ตัวบรรจง / BLOCK LETTER",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text: "____________________________________________________________",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [170, 0, 0, 20],
                },
                {
                  text: "บริษัทหรือตัวแทน / FIRM OR AGENT",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text: "____________________________________________________________",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [170, 0, 0, 20],
                },
                {
                  text: "วันที่ / DATE ",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text: "________________________เวลา / TIME__________________________",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [170, 0, 0, 20],
                },
                {
                  text: "ผู้จัดทำเอกสาร",
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, -20],
                },
                {
                  text: response.data.dlvOrders[0].editor,
                  fontSize: 16,
                  // style: "title",

                  // alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [170, 0, 0, 20],
                },
                {
                  qr: response.data.dlvOrders[0].number,
                  fit: "60",
                  alignment: "center",
                  margin: [0, 0, 0, 20],
                  // absolutePosition: { x: 500, y: 100 },
                  // absolutePosition: { x: 480, y: 30 },
                },
                {
                  image: this.textToBase64Barcode(
                    response.data.dlvOrders[0].number
                  ),
                  width: 150,
                  height: 40,
                  // absolutePosition: { x: 430, y: 145 },
                  alignment: "center",
                  margin: [0, 0, 0, 10],
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
                columnGap: 20,
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 2000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
    },
    cusEdit() {
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/dlvorders/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async goTrigger() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/receipts/recTrigger`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Trigger Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          // this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  components: {
    aggrid,
    putadd,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
